// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"816bbc4c","643":"254ae2e6"}[chunkId] + ".chunk.js";
};